import sc from 'web/components/styled';
import themeClasses from 'web/styles/themeClasses.css';
import themeConstants from 'web/styles/themeConstants';

export const NoticeCard = sc.div(themeClasses({ borderRadius: 'sm', paddingX: 5, paddingY: 3 }), {
  border: `1px solid ${themeConstants.palette.yellow[600]}`,
  backgroundColor: themeConstants.palette.yellow[300],
});
